export default {
  drawLine: 'Match Lines',
  drawLineComponent: 'Match Line Component',
  viewDrawLineArea: 'View Start and End Regions',
  setDrawLineArea: 'Set Up Start and End Regions',
  onlyOneDrawLineTip:
    'The same scene supports adding only one Match Lines or Draw Lines component.',
  addGroupWarning: 'Grouping of line components is not allowed.',
  setDrawLine: 'Set Up the Match Line Component',
  drawLineEdit: {
    drawLineArea: 'Start and End Regions',
    addDrawLineArea: 'Add Start and End Regions',
    pairRelation: 'Pairing Relationship',
    pairWay: 'Pairing Method',
    pairCategory: 'Matching Category',
    addPairRelation: 'Add Pairing Relationships',
    pairDefaultName: 'Pair',
    areaPlaceholder: 'Select Start and End Regions',
    noAreaTip: 'Please add start and end regions first.',
    notAllowLineAgain:
      'Once the connection is successful, no further connection is allowed',
    lineStyle: 'Line Style',
    lineSizePlaceholder: 'Line Thickness',
    applyToOther: 'Apply to All',
    preview: 'Preview All Lines',
    closePreview: 'Close Preview',
    renameIsTooLongTip: 'Only supports within {len} characters.',
    renameIsEmptyTip: 'Name cannot be empty.',
    deletePairConfirmTip:
      'Pairing linked to game logic. Deletion is irreversible. Are you sure to delete?',
    deleteAreaConfirmTip:
      'Start and end regions linked to game logic. Deletion is irreversible. Are you sure to delete?',
    cancel: 'Cancel',
    ok: 'Delete',
    category: {
      addCategory: 'Add Pairing Category',
      enterCategoryPlaceholder: 'Please enter the matching category.',
      nameDuplicateTip: 'Cannot have the same name as existing categories.',
      nameRegTip:
        'Supports English, Chinese, numbers, underscores; max 20 characters.',
      deleteComfirm: 'Deletion is irreversible. Are you sure to delete?',
      noData: 'No Data',
      noDataTip: 'Click to Add a Pairing Category',
    },
    match: {
      isMatch: 'Match or not',
      placeholder: 'Select Match',
      match: 'Match',
      noMatch: 'Not Match',
      pairPlaceholder: 'Select Pairing',
      pairWayPlaceholder: 'Select Pairing Method',
      pairCategoryPlaceholder: 'Select Pairing Category',
    },
    lineDir: {
      title: 'Line Pairing',
      singleDir: 'One-way',
      doubleDir: 'Two-way',
    },
    lineType: {
      title: 'Line Types',
      trajectoryLine: 'Free-hand Drawing',
      straightLine: 'Straight Line',
    },
    splitText: "[Region's Position and Size] Separate Setting",
    splitTip:
      "The region's position and size can be set separately in different values for horizontal and vertical screens.",
    vpEraseLineTip:
      'Only applies to straight lines, not to free-hand drawings.',
    vpModifyLineStyleTip:
      'Free-hand Drawing: Only undrawn lines work.<br/>Straight Line: Both drawn and undrawn lines work.',
    vpModifyPairLineStyle:
      'Only applies to straight lines, not to free-hand drawings.',
    pairTip: "Completed connections can't be redrawn.",
    areaTip:
      'Style for lines drawn from this area.<br/>Pairing must be set up for this area to draw lines.',
  },
  freeDrawLine: 'Draw Lines',
  freeDrawLineComponent: 'Draw Lines Component',
  setFreeDrawLine: 'Set Up Line Style',
  setFreeDrawLineStyle: 'Line Style',
  freeDrawLineEdit: {
    tab: 'Line',
    preview: 'Preview Line',
    closePreview: 'Close Preview',
    vpFreeEraseLineTip: 'Clear All Lines',
    vpFreeModifyLineStyleTip: 'Effective for undrawn lines only.',
  },
}
